import { WebhookDto } from "@intelligems/ig-types";
import { organizationsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrgId } from "../organizations/get-organization";

export const useGetWebhooks = () => {
  const orgId = useGetOrgId();

  return useQuery({
    queryKey: organizationsKeys.webhooks(orgId),
    queryFn: async (): Promise<WebhookDto[]> => {
      const response = await api.get<WebhookDto[]>(`/v2/webhooks`);
      return response.data;
    },
  });
};
